module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "frontflap"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('strong', [_vm._v("GARBAGE PAIL KIDS")]), _vm._v("—a series of collectible stickers produced by Topps in the 1980s—combined spectacular artwork and over-the-top satire. The result was an inspired collaboration between avant-garde cartoonists and humorists including Art Spiegelman, Mark Newgarden, John Pound, Tom Bunk, and Jay Lynch. This first-ever compilation of Series 1 through Series 5 from 1985 and 1986 celebrates this pop culture phenomenon, and includes images of all 206 rare and hard-to-find stickers."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "frontflap"
  }, [_vm._v("Copyright © 2012 The Topps Company, Inc. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/frondcase.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/endpaper1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/endpaper2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/endpaper3.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f6c4f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm01.vue
// module id = 60
// module chunks = 0